<template>
	<el-container class="main">
		<!-- <el-main ref="box" id="searchBar"> -->
		<el-main id="searchBar">
			<el-row class="header" v-show="showHeader">
				<!-- <el-col :span="12" class="logo-top"><img src="../assets/img/global/yunmu-top-logo.png" alt="" /></el-col> -->
				<el-col :span="12" class="logo-top2"><span class="iconfont iconlogobig"></span></el-col>
				<el-col :span="12" class="headerRight">
					<!-- <span @click="changeColor(1)">换肤</span> -->
<!--					<el-popover class="mtNO" width="115" popper-class="mtNO" placement="bottom" trigger="hover" content="400-800-900">-->
<!--						<down-load></down-load>-->
<!--						<span class="curpointer" slot="reference">-->
<!--							<i class="iconfont icontoptel main-icon"></i>-->
<!--						</span>-->
<!--					</el-popover>-->

					<el-popover class="mtNO" width="115" popper-class="mtNO" placement="bottom" trigger="hover" content="400-800-900">
						<div class="textC">17308491715</div>
						<span class="curpointer" slot="reference">
							<i class="iconfont icontoprexian main-icon"></i>
						</span>
					</el-popover>

					<span>
						<i class="iconfont iconditu main-icon mr5" style="font-size: 22px;"></i>
						<span>{{ userInfo && userInfo.custInfo.curname }}</span>
					</span>
					<span class="curpointer" @click="logoutSys">
						<i class="iconfont icontuichu main-icon mr5" style="font-size: 22px;"></i>
						<span class="userName textOverOneLine">{{ userInfo.userName }}</span>
					</span>
				</el-col>
				<!--  -->
			</el-row>

			<el-row :class="{ fixedMenu: fixedMenu }" ref="menu" class="menuBlock">
				<el-menu
					:default-active="activePath"
					class="el-menu-demo"
					mode="horizontal"
					@select="handleSelect"
					background-color="#1a9df2"
					text-color="#fff"
					active-text-color="#fff"
					router
				>
					<!-- <el-menu-item :index="item.path" v-for="item in menuList" :key="item.id">{{item.name}}</el-menu-item> -->
					<div v-for="item in menuList" :key="item.id" :item="item" class="el-menu-item-box">
						<el-menu-item :index="item.path" v-if="item.childs.length === 0">{{ item.name }}</el-menu-item>
						<el-submenu :index="item.path" v-else-if="!isReadonly">
							<template slot="title">
								{{ item.name }}
							</template>
							<el-menu-item :index="it.path" v-for="it in item.childs" :key="it.id" >
								<!-- <i class="iconfont iconyujingshezhi menu-icon hovertext" v-if="it.id === '6-1'"></i>
								<i class="iconfont iconxiugai1 menu-icon hovertext" v-if="it.id === '6-2'"></i> -->
								<i class="iconfont menu-icon hovertext" :class="it.icon"></i>
								{{ it.name }}
							</el-menu-item>
						</el-submenu>
					</div>
				</el-menu>
			</el-row>
			<el-row :class="{ marginT: fixedMenu,firefoxH:isFirefox }" class="routerBlock" ref="box">
				<router-view></router-view>
				<!-- <keep-alive><router-view></router-view></keep-alive> -->
			</el-row>
		</el-main>
		<!-- <el-footer>
			<el-row type="flex" justify="space-between">
				<el-col :span="8">
					<img src="../assets/img/global/bt-dizhi.png" alt="" />
					湖南省长沙市开福区马栏山创智园7栋
				</el-col>
				<el-col :span="8">
					<img src="../assets/img/global/dianhua.png" alt="" />
					0731-85511307（早上8：00 -- 晚上20：00）
				</el-col>
				<el-col :span="8">
					<img src="../assets/img/global/bei.png" alt="" />
					2019云目未来 京ICP备19043729号
				</el-col>
			</el-row>
		</el-footer> -->
		<transition name="fade">
			<div class="warning-window-block" v-if="!iscloseWarning"><warning-window :warnList="warnList" ref="warningWindow" @onClose="closeWarning"></warning-window></div>
		</transition>

		<system-notice ref="systemNotice"></system-notice>
		<version-update ref="versionUpdate" :sysMsg="messageInfo"></version-update>
		<overdue-prompt ref="overduePrompt" @loginOut="loginOut"></overdue-prompt>
	</el-container>
</template>

<script>
import DownLoad from '@/views/components/main/DownLoad.vue';
import WarningWindow from '@/views/components/main/WarningWindow.vue';
import SystemNotice from '@/views/components/main/SystemNotice.vue';
import VersionUpdate from '@/views/components/main/VersionUpdate.vue';
import loginApi from '@/api/login';
import warningApi from '@/api/warning';
import OverduePrompt from '@/views/components/main/OverduePrompt.vue';
export default {
	components: {
		DownLoad,
		WarningWindow,
		SystemNotice,
		VersionUpdate,
		OverduePrompt
	},
	data() {
		return {
			warnList: [],
			activePath: '',
			fixed: false,
			box: null,
			nums: 1,
			iscloseWarning2: false,
            isShowSetting:true,
			menuList: [
				{
					path: '/home/home',
					id: '1',
					name: '首页',
					childs: []
				},
				{
					path: '/monitoring/monitoring',
					id: '2',
					name: '舆情监测',
                    childs: []
				},
				{
					path: '/earlyWarning/earlyWarning',
					id: '3',
					name: '预警舆情',
                    childs: []
				},
				{
					path: '/search/search',
					id: '4',
					name: '舆情搜索',
                    childs: []
				},
				{
					path: '/statistics/statistics',
					id: '5',
					name: '统计分析',
                    childs: []
				},
				{
					path: 'none',
					id: '6',
					name: '系统设置',
					childs: [
						{
							path: '/system/system',
							id: '6-1',
							icon:'iconyujingshezhi',
							name: '预警设置'
						},
						{
							path: '/changePassword/changePassword',
							id: '6-2',
							icon:'iconxiugai1',
							name: '修改密码'
						},
						{
							path: '/systemAuth/systemAuth',
							id: '6-3',
							icon:'iconquanxian',
							name: '权限管理'
						}
					]
				}
			],
			thmeId: '',
			pageId: '',
			messageInfo: {},
			timer: null,
			imgUrl: '',
			isFirefox:false,
			userInfo:{}
		};
	},
	created() {
		
		this.initPage();
		// console.log(this.$cookies.get('userInfo'))
		
		if (this.$cookies.get('userInfo')) {
			this.userInfo = this.$cookies.get('userInfo');
			// console.log(this.userInfo)
			if(this.userInfo.readOnly === 1){
				 this.$store.commit('setIsReadonly', true);
			}else{
				this.$store.commit('setIsReadonly', false);
			}
		} else {
			// this.$router.go(0);
		}
		this.getUserAgent()
	},
	mounted() {
		
		// this.$store.commit('toggleshowHeader', true)
		this.box = this.$refs.box;
		this.box.$el.addEventListener('scroll', this.fixedActiveBtn);
		this.delayedCloseWarning();
		//this.showSystemNotice()
		this.getSysMsg();
		this.initWarnTip();
		// this.$refs.systemNotice.show({content:'jjjjjjjjjjj'})
		// this.$refs.versionUpdate.show({content:'jjjjjjjjjjj'})
		if (this.$cookies.get('userInfo')) {
			//验证是否逾期
			//this.userInfo.ifback //1是客服 0是用户
			if (this.userInfo.ifback === 1) {
				this.$store.commit('setIfBack', true);
			} else {
				this.$store.commit('setIfBack', false);
			}

			this.isOverdue();
		} else {
			this.$router.go(0);
		}

		if (window.history && window.history.pushState) {
			history.pushState(null, null, document.URL);
			window.addEventListener('popstate', this.cancel, false);
		}
		
	},
	beforeDestroy() {
		clearTimeout(this.timer);
	},
	destroyed() {
		window.removeEventListener('popstate', this.cancel, false);
	},
	computed: {
		fixedMenu() {
			return this.$store.state.fixedMenu;
		},
		showHeader() {
			return this.$store.state.showHeader;
		},
		iscloseWarning() {
			return this.$store.state.iscloseWarning;
		},
		isReadonly(){
			return this.$store.state.isReadonly;
		}
	},
	methods: {
		closeWarning2() {
			this.iscloseWarning2 = false;
		},
		toggle() {
			this.iscloseWarning2 = !this.iscloseWarning2;
		},
		//显示全局提示框的 示例调用
		showCon() {
			this.$my_confirm('请选择要编辑的数据?', {
				yesBtnText: '确 定', //确定按钮的文字
				cancelBtnText: '取 消', //取消按钮的文字
				type: 'warning', //
				isShowCancelBtn: true //是否显示取消按钮
			})
				.then(() => {
					//点登录
				})
				.catch(() => {
					//点取消
				});
		},
		logoutSys() {
			let that = this;
			this.$my_confirm('确定退出吗？', {
				type: 'warning', //
				isShowCancelBtn: true //是否显示取消按钮
			})
				.then(() => {
					loginApi.logout().then(res => {
						that.$cookies.remove('userInfo');
						that.$cookies.remove('isLogin');
						this.$router.push('/');
					});
				})
				.catch(() => {
					//点取消
				});
		},
		//导航菜单 存到本地
		handleSelect(key, keyPath) {
			this.activePath = key;
			window.sessionStorage.setItem('activePath', key);
			this.initfixedActiveBtn();
		},
		//页面滚动事件
		fixedActiveBtn() {
			if (this.box.$el.scrollTop >= 200) {
				this.$store.commit('toggleFixedMenu', true);
				this.$store.commit('toggleshowHeader', false);
			} else if (this.box.$el.scrollTop < 66) {
				this.$store.commit('toggleFixedMenu', false);
				this.$store.commit('toggleshowHeader', true);
			}
			if (this.box.$el.scrollTop >= 508) {
				this.$store.commit('toggleRightFixedbottom', true);
			} else {
				this.$store.commit('toggleRightFixedbottom', false);
			}
		},
		//初始化 头部定位逻辑
		initfixedActiveBtn() {
			this.$store.commit('toggleFixedMenu', false);
			this.$store.commit('toggleshowHeader', true);
			//初始化 头部定位逻辑
		},
		initPage() {
			//thmeId:
			// pageId:
			//判断如果不是从其他页面跳转到新窗口的
			if (!this.$route.query.thmeId || !this.$route.query.pageId) {
				let activePath = window.sessionStorage.getItem('activePath');
				if (!activePath) {
					// console.log('没有存 seession')
				     this.activePath = '/home/home';
				} else {
					this.activePath = activePath;
				}
				this.$router.push(this.activePath).catch(err => {
					err;
				});
			} else {
				//如果是从被跳转到新窗口的
				//设置变量的值

				this.activePath = this.$route.path;
			}

			let className = localStorage.getItem('app');
			if (!className) {
				document.getElementsByTagName('body')[0].className = 'theme' + 1;
				//document.getElementById('app').className = 'theme' + 1;
			} else {
				document.getElementsByTagName('body')[0].className = className;
				//	document.getElementById('app').className = className;
			}
		},
		initWarnTip: function() {
			clearTimeout(this.timer);
			let that = this;
			warningApi.list({ warnType: '1,2', deleted: 0, sort: 3, days: 0, pageNo: 1, pageSize: 4 }).then(res => {
				if (res.returnCode != '1001') {
					return;
				}

				let resultData = res.returnData;
				if (resultData.data.length > 0) {
					let maxId = resultData.data[0].id;
					let nowId = that.$cookies.get('nowWarnId.' + that.userInfo.usid);
					if (maxId > nowId) {
						that.$cookies.set('nowWarnId.' + that.userInfo.usid, maxId);
						that.warnList = resultData.data;
						that.$store.commit('closeWarning', false);
					}
				}
			});
			this.timer = setTimeout(() => {
				that.initWarnTip();
			}, 10000);
		},
		//更换主题
		changeColor(num) {
			//测试切换
			if (this.nums === 1) {
				this.nums = 2;
			} else {
				this.nums = 1;
			}
			//把className theme1，theme2，theme3挂载在app.vue的<div id="app"></div>上
			document.getElementsByTagName('body')[0].className = 'theme' + this.nums;
			//document.getElementById('app').className = 'theme' + this.nums;
			this.localStorageDate();
		},
		//存储localStoarge，用于进入系统时，记住用户上一次的选择，自动加载用户上一次选择的主题主题，记得在mounted()里面调用
		localStorageDate() {
			//localStorage.setItem('app', document.getElementById('app').className)
			localStorage.setItem('app', document.getElementsByTagName('body')[0].className);
		},
		closeWarning() {
			this.$store.commit('closeWarning', true);
		},
		delayedCloseWarning() {
			// if (!this.iscloseWarning) {
			// 	setTimeout(() => {
			// 		this.closeWarning();
			// 	}, 15000);
			// }
		},
		showSystemNotice() {
			this.$refs.systemNotice.show(this.messageInfo);
		},
		showVersionUpdate() {
			this.$refs.versionUpdate.show(this.messageInfo);
		},
		getSysMsg: function() {
			let that = this;
			loginApi.getSysMsg().then(res => {
				that.messageInfo = res.returnData;
				if (that.messageInfo.type && that.messageInfo.type == 1) {
					that.showSystemNotice();
				} else if (that.messageInfo.type == 2) {
					that.showVersionUpdate();
				}
			});
		},
		isOverdue: function() {
			let dueDate = this.userInfo.custInfo.dueDate;
			let currentdate = new Date();
			if (new Date(dueDate).getTime() < currentdate.getTime()) {
				this.$refs.overduePrompt.show();
			}
		},
		loginOut: function() {
			loginApi.logout().then(res => {
				this.$cookies.remove('userInfo');
				this.$cookies.remove('isLogin');
				this.$router.push('/');
			});
		},
		cancel: function() {
			this.handleSelect(this.$route.path, [this.$route.path]);
		},
		getUserAgent: function() {
			var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
			//判断是否Firefox浏览器
			if (userAgent.indexOf('Firefox') > -1) {
				this.isFirefox = true
			}
		}
	},
	watch: {
		iscloseWarning: function(newVal, oldVal) {
			this.delayedCloseWarning();
		},
		$route: function(newVal, oldVal) {
			// console.log(oldVal)
			// console.log(newVal)
			//判断是不是由首页点击跳转到预警舆情的
			if (newVal.name === 'earlyWarning' && newVal.query.isPush === '1') {
				this.handleSelect('/earlyWarning/earlyWarning', ['/earlyWarning/earlyWarning']);
			}
			
		},
        $showBlock: function (newVal, oldVal) {
            // console.log(newVal, oldVal)
        }
	}
};
</script>

<style lang="less">
@import '../assets/css/page/main.less';
</style>
